import ReportActivityList from './ReportActivityList';

export default ReportActivityList;
